<template>
  <div>
    <RMSFieldLabel
      v-if="config.showLabel ?? true"
      :fieldId="fieldId"
      :fieldLabel="config.label"
      :config="{ showAvailable: false, showRequired: false }"
    />
    <Password
      :id="fieldId"
      v-model="userText"
      class="inputfield w-full h-[2.65rem]"
      toggleMask
      :disabled="disabled"
      :placeholder="config.placeholder ?? undefined"
      :feedback="config.feedback ?? undefined"
      :class="!inputIsValid ? 'p-invalid' : ''"
      :inputClass="'w-full'"
      @update:model-value="onUpdateModelValue"
    >
      <template #footer>
        <Divider/>
        <ul class="pl-2 my-0 leading-normal text-sm">
          <li>At least one lowercase</li>
          <li>At least one uppercase</li>
          <li>At least one numeric</li>
          <li>Minimum 8 characters</li>
        </ul>
      </template>
    </Password>
    <span v-if="!inputIsValid" class="text-sm text-red-600">{{ validInputDescription }}</span>
  </div>
</template>
<script>
import { ref } from 'vue'
import RMSFieldLabel from '@/components/fields/RMSFieldLabel.vue'
import Divider from 'primevue/divider'
import Password from 'primevue/password'

export default {
  name: 'RMSPassword',
  components: {
    Password,
    RMSFieldLabel,
    Divider,
  },
  props: {
    fieldId: {
      type: String,
      default: 'rms-password'
    },
    config: {
      type: Object,
      default: () => {}
    },
    validInputRegEx: {
      type: RegExp,
      default: () => undefined
    },
    validInputDescription: {
      type: String,
      default: () => undefined
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
  },
  emits: ['onValidInput', 'onInvalidInput', 'onClear', 'onBlur'],
  setup(props, { emit }) {
    const userText = ref(undefined)
    const inputIsValid = ref(true)

    const onUpdateModelValue = (val) => {
      if (val === '') {
        inputIsValid.value = true
        emit('onClear')
        return
      }

      if (props.validInputRegEx) {
        if (props.validInputRegEx.test(val)) {
          inputIsValid.value = true
          emit('onValidInput', val)
        } else {
          inputIsValid.value = false
          emit('onInvalidInput', val)
        }
      } else {
        inputIsValid.value = true
        emit('onValidInput', val)
      }
    }

    return {
      userText,
      inputIsValid,
      onUpdateModelValue,
    }
  },
}
</script>
